// This directive shows an area graph of all Broadcasts today.
angular.module('app.directives').directive('broadcastsTodayGraph', Broadcast =>
    ({
        restrict: 'E',
        template: `
        <div class="events-by-hour-graph" style="height:50px">
           <app-rickshaw ng-if="countByHourData.length" rickshaw-options="{height: 50}" rickshaw-features="eventsByHourFeatures" rickshaw-series="eventsByHourSeries"></app-rickshaw>
        </div>
        `,
        controller($scope) {
            const todayRange = (new Date()).todayRangeUTC();

            const hourRangeForBroadcast = function(b) {
                const start = new Date(b.starts_at);
                const stops = new Date(b.stops_at);
                if (start.getDate() !== stops.getDate()) {
                    return _.range(start.getHours(), 24); //wraps around midnight
                } else {
                    return _.range(start.getHours(), stops.getHours() + 1);
                }
            };

            const idxToDate = function(k) {
                const dt = new Date();
                dt.setHours(k);
                dt.setMinutes(0);
                dt.setSeconds(0);
                return dt.getTime() / 1000;
            };

            return Broadcast.query({
                "filter.exclude_disallowed_accounts": "true",
                "filter.include_archived": "false",
                q: `+starts_at:[${todayRange.from} TO ${todayRange.to}]`,
                l: 1000
            }, function(data, getResponseHeader) {
                const todayBroadcasts = _.map(data, b => ({ hours: hourRangeForBroadcast(b) }));

                const countByHour = {};
                _.each(_.range(24), h =>
                    countByHour[h] = _.reduce(
                        todayBroadcasts,
                        function(sum, b) {
                            let left;
                            return sum + ((left = Array.from(b.hours).includes(h)) != null ? left : {
                                [1]: 0
                            });
                        },
                        0
                    )
                );

                const countByHourHoverFormatter = function(series, x, y) {
                    let content;
                    return content = `<strong>${y}</strong> event(s) at <strong>${new Date(x * 1000).toLocaleTimeString()}</strong>`;
                };

                $scope.countByHourData = _.map(countByHour, (v, k) => ({ x: idxToDate(k), y: parseInt(v) }));

                $scope.eventsByHourSeries = [{
                    name: 'Number of Events Today By Hour',
                    renderer: 'bar',
                    data: $scope.countByHourData,
                    color: 'rgba(0,0,0,0.5)'
                }];

                return $scope.eventsByHourFeatures = {
                    yAxis: false,
                    xAxis: false,
                    annotate: [
                        { x: (new Date()).getTime() / 1000, label: 'Now' }
                    ],
                    hover: {
                        xFormatter: false,
                        yFormatter: false,
                        formatter: countByHourHoverFormatter
                    }
                };
            });
        }
    }));


// WEBPACK FOOTER //
// ./directives/broadcasts_today_graph.js